
import { WorldCountry } from '../types';

// Fase 12 - Expansión África: Marruecos expandido + nuevos países africanos
export const africaExpansion5: WorldCountry[] = [
  // Marruecos expandido (Fase 12)
  {
    name: 'Morocco',
    slug: 'morocco',
    code: 'MA',
    population: 36910560,
    topCities: [
      { name: 'Casablanca', slug: 'casablanca', population: 3359818 },
      { name: 'Rabat', slug: 'rabat', population: 577827 },
      { name: 'Fez', slug: 'fez', population: 1112072 },
      { name: 'Marrakech', slug: 'marrakech', population: 928850 },
      { name: 'Tangier', slug: 'tangier', population: 947952 },
      { name: 'Salé', slug: 'sale', population: 890403 },
      { name: 'Meknes', slug: 'meknes', population: 632079 },
      { name: 'Oujda', slug: 'oujda', population: 494252 },
      { name: 'Kenitra', slug: 'kenitra', population: 431282 },
      { name: 'Agadir', slug: 'agadir', population: 421844 },
      { name: 'Tetouan', slug: 'tetouan', population: 380787 },
      { name: 'Temara', slug: 'temara', population: 313510 },
      { name: 'Safi', slug: 'safi', population: 308508 },
      { name: 'Mohammedia', slug: 'mohammedia', population: 208612 },
      { name: 'Khouribga', slug: 'khouribga', population: 196196 },
      { name: 'El Jadida', slug: 'el-jadida', population: 194934 },
      { name: 'Beni Mellal', slug: 'beni-mellal', population: 192676 },
      { name: 'Taza', slug: 'taza', population: 148456 },
      { name: 'Nador', slug: 'nador', population: 161726 },
      { name: 'Settat', slug: 'settat', population: 142250 },
      { name: 'Larache', slug: 'larache', population: 125008 },
      { name: 'Khemisset', slug: 'khemisset', population: 131542 },
      { name: 'Guelmim', slug: 'guelmim', population: 95749 },
      { name: 'Berrechid', slug: 'berrechid', population: 136634 },
      { name: 'Ksar El Kebir', slug: 'ksar-el-kebir', population: 126617 },
      { name: 'Al Hoceima', slug: 'al-hoceima', population: 56716 },
      { name: 'Taourirt', slug: 'taourirt', population: 91601 },
      { name: 'Taroudant', slug: 'taroudant', population: 92850 },
      { name: 'Ouarzazate', slug: 'ouarzazate', population: 71067 },
      { name: 'Sidi Kacem', slug: 'sidi-kacem', population: 75508 },
      { name: 'Youssoufia', slug: 'youssoufia', population: 67628 },
      { name: 'Fnideq', slug: 'fnideq', population: 53526 },
      { name: 'Errachidia', slug: 'errachidia', population: 92374 },
      { name: 'Essaouira', slug: 'essaouira', population: 85433 },
      { name: 'Kelaa Des Sraghna', slug: 'kelaa-des-sraghna', population: 108753 },
      { name: 'Sidi Slimane', slug: 'sidi-slimane', population: 79418 },
      { name: 'Tiznit', slug: 'tiznit', population: 74699 },
      { name: 'Tifelt', slug: 'tifelt', population: 86038 },
      { name: 'Azrou', slug: 'azrou', population: 54275 },
      { name: 'Dakhla', slug: 'dakhla', population: 106277 },
      { name: 'Laayoune', slug: 'laayoune', population: 271813 },
      { name: 'Tan-Tan', slug: 'tan-tan', population: 73209 },
      { name: 'Ifrane', slug: 'ifrane', population: 14659 },
      { name: 'Midelt', slug: 'midelt', population: 58797 },
      { name: 'Skhirate', slug: 'skhirate', population: 33450 },
      { name: 'Harhoura', slug: 'harhoura', population: 19328 },
      { name: 'Boujdour', slug: 'boujdour', population: 46129 },
      { name: 'Smara', slug: 'smara', population: 57035 },
      { name: 'Ain Harrouda', slug: 'ain-harrouda', population: 18391 },
      { name: 'Bouznika', slug: 'bouznika', population: 39358 },
      { name: 'Benslimane', slug: 'benslimane', population: 47642 },
      { name: 'Sidi Bennour', slug: 'sidi-bennour', population: 42637 },
      { name: 'Azemmour', slug: 'azemmour', population: 40920 },
      { name: 'Al Aaroui', slug: 'al-aaroui', population: 36021 },
      { name: 'Jerada', slug: 'jerada', population: 43506 },
      { name: 'Ain Taoujdat', slug: 'ain-taoujdat', population: 29466 },
      { name: 'Oulad Teima', slug: 'oulad-teima', population: 67038 },
      { name: 'Ben Guerir', slug: 'ben-guerir', population: 62051 },
      { name: 'Ahfir', slug: 'ahfir', population: 12359 },
      { name: 'Berkane', slug: 'berkane', population: 109237 },
      { name: 'Saidia', slug: 'saidia', population: 9000 },
      { name: 'Martil', slug: 'martil', population: 41370 },
      { name: 'M\'diq', slug: 'mdiq', population: 56227 },
      { name: 'Chefchaouen', slug: 'chefchaouen', population: 42786 },
      { name: 'Ouezzane', slug: 'ouezzane', population: 59606 },
      { name: 'Sidi Yahya El Gharb', slug: 'sidi-yahya-el-gharb', population: 22540 },
      { name: 'Souk El Arbaa', slug: 'souk-el-arbaa', population: 31187 },
      { name: 'Mechra Bel Ksiri', slug: 'mechra-bel-ksiri', population: 17750 },
      { name: 'Lalla Mimouna', slug: 'lalla-mimouna', population: 13792 },
      { name: 'Sidi Taibi', slug: 'sidi-taibi', population: 25028 },
      { name: 'Ain Atiq', slug: 'ain-atiq', population: 18109 },
      { name: 'Zaio', slug: 'zaio', population: 27514 },
      { name: 'Ras El Ma', slug: 'ras-el-ma', population: 16799 },
      { name: 'Missour', slug: 'missour', population: 20978 },
      { name: 'Moulay Bousselham', slug: 'moulay-bousselham', population: 11902 },
      { name: 'Arbaoua', slug: 'arbaoua', population: 12015 },
      { name: 'Souk Sebt Oulad Nemma', slug: 'souk-sebt-oulad-nemma', population: 23845 },
      { name: 'Had Soualem', slug: 'had-soualem', population: 20984 },
      { name: 'Oulad Ayad', slug: 'oulad-ayad', population: 21039 },
      { name: 'El Gara', slug: 'el-gara', population: 13412 },
      { name: 'Lqliaa', slug: 'lqliaa', population: 25582 },
      { name: 'Lamkansa', slug: 'lamkansa', population: 15630 },
      { name: 'Selouane', slug: 'selouane', population: 9211 },
      { name: 'Imzouren', slug: 'imzouren', population: 26802 },
      { name: 'Asilah', slug: 'asilah', population: 31420 },
      { name: 'Ksar Sghir', slug: 'ksar-sghir', population: 11044 },
      { name: 'Cabo Negro', slug: 'cabo-negro', population: 8521 },
      { name: 'Dar Bouazza', slug: 'dar-bouazza', population: 75000 },
      { name: 'Bouskoura', slug: 'bouskoura', population: 82500 },
      { name: 'Nouaceur', slug: 'nouaceur', population: 35806 },
      { name: 'Mediouna', slug: 'mediouna', population: 25872 },
      { name: 'Tit Mellil', slug: 'tit-mellil', population: 54200 },
      { name: 'Sidi Moumen', slug: 'sidi-moumen', population: 690000 },
      { name: 'Hay Hassani', slug: 'hay-hassani', population: 580000 },
      { name: 'Ain Chock', slug: 'ain-chock', population: 540000 },
      { name: 'Ben M\'sik', slug: 'ben-msik', population: 490000 },
      { name: 'Sidi Othman', slug: 'sidi-othman', population: 470000 },
      { name: 'Al Fida', slug: 'al-fida', population: 410000 },
      { name: 'Moulay Rachid', slug: 'moulay-rachid', population: 300000 },
      { name: 'Anfa', slug: 'anfa', population: 250000 },
      { name: 'Mers Sultan', slug: 'mers-sultan', population: 200000 },
      { name: 'Roches Noires', slug: 'roches-noires', population: 180000 },
      { name: 'Ain Sebaa', slug: 'ain-sebaa', population: 290000 },
      { name: 'Hay Mohammadi', slug: 'hay-mohammadi', population: 270000 },
      { name: 'Sbata', slug: 'sbata', population: 150000 },
      { name: 'Sidi Bernoussi', slug: 'sidi-bernoussi', population: 420000 },
      { name: 'Zenata', slug: 'zenata', population: 95000 },
      { name: 'Oulfa', slug: 'oulfa', population: 85000 }
    ]
  },
  // Túnez expandido (Fase 12)
  {
    name: 'Tunisia',
    slug: 'tunisia',
    code: 'TN',
    population: 11818619,
    topCities: [
      { name: 'Tunis', slug: 'tunis', population: 693210 },
      { name: 'Sfax', slug: 'sfax', population: 330440 },
      { name: 'Sousse', slug: 'sousse', population: 271428 },
      { name: 'Kairouan', slug: 'kairouan', population: 186653 },
      { name: 'Bizerte', slug: 'bizerte', population: 136917 },
      { name: 'Gabès', slug: 'gabes', population: 152921 },
      { name: 'Ariana', slug: 'ariana', population: 114486 },
      { name: 'Gafsa', slug: 'gafsa', population: 111170 },
      { name: 'Monastir', slug: 'monastir', population: 104535 },
      { name: 'Ben Arous', slug: 'ben-arous', population: 74842 },
      { name: 'Kasserine', slug: 'kasserine', population: 114463 },
      { name: 'Médenine', slug: 'medenine', population: 61705 },
      { name: 'Nabeul', slug: 'nabeul', population: 63327 },
      { name: 'Béja', slug: 'beja', population: 57245 },
      { name: 'Jendouba', slug: 'jendouba', population: 51408 },
      { name: 'Tataouine', slug: 'tataouine', population: 59346 },
      { name: 'Mahdia', slug: 'mahdia', population: 62189 },
      { name: 'El Kef', slug: 'el-kef', population: 45191 },
      { name: 'Sidi Bouzid', slug: 'sidi-bouzid', population: 42931 },
      { name: 'Siliana', slug: 'siliana', population: 27047 },
      { name: 'Zaghouan', slug: 'zaghouan', population: 20837 },
      { name: 'Manouba', slug: 'manouba', population: 51200 },
      { name: 'La Marsa', slug: 'la-marsa', population: 92987 },
      { name: 'Hammam Lif', slug: 'hammam-lif', population: 65754 },
      { name: 'Hammam Chott', slug: 'hammam-chott', population: 25000 },
      { name: 'Ezzahra', slug: 'ezzahra', population: 36226 },
      { name: 'Radès', slug: 'rades', population: 59794 },
      { name: 'Megrine', slug: 'megrine', population: 33421 },
      { name: 'Mohamedia', slug: 'mohamedia-tunisia', population: 78031 },
      { name: 'Fouchana', slug: 'fouchana', population: 36031 },
      { name: 'Mornag', slug: 'mornag', population: 23688 },
      { name: 'Skhira', slug: 'skhira', population: 7903 },
      { name: 'El Hamma', slug: 'el-hamma', population: 34835 },
      { name: 'Mareth', slug: 'mareth', population: 17750 },
      { name: 'Zarzis', slug: 'zarzis', population: 79912 },
      { name: 'Djerba Houmt Souk', slug: 'djerba-houmt-souk', population: 75904 },
      { name: 'Midoun', slug: 'midoun', population: 63528 },
      { name: 'Ajim', slug: 'ajim', population: 24294 },
      { name: 'Guellala', slug: 'guellala', population: 9186 },
      { name: 'Mellita', slug: 'mellita', population: 8370 },
      { name: 'Mahres', slug: 'mahres', population: 20640 },
      { name: 'Jebeniana', slug: 'jebeniana', population: 12855 },
      { name: 'Menzel Chaker', slug: 'menzel-chaker', population: 11705 },
      { name: 'Sakiet Ezzit', slug: 'sakiet-ezzit', population: 37088 },
      { name: 'Sakiet Eddaier', slug: 'sakiet-eddaier', population: 30402 },
      { name: 'Thyna', slug: 'thyna', population: 26635 },
      { name: 'Agareb', slug: 'agareb', population: 10635 },
      { name: 'Bir Ali Ben Khelifa', slug: 'bir-ali-ben-khelifa', population: 13451 },
      { name: 'El Hencha', slug: 'el-hencha', population: 7604 },
      { name: 'Skhira', slug: 'skhira-2', population: 15830 }
    ]
  },
  // Sudán (Fase 12)
  {
    name: 'Sudan',
    slug: 'sudan',
    code: 'SD',
    population: 43849260,
    topCities: [
      { name: 'Khartoum', slug: 'khartoum', population: 5274321 },
      { name: 'Omdurman', slug: 'omdurman', population: 2395159 },
      { name: 'Khartoum North', slug: 'khartoum-north', population: 1012211 },
      { name: 'Kassala', slug: 'kassala', population: 401477 },
      { name: 'Port Sudan', slug: 'port-sudan', population: 394561 },
      { name: 'Obeid', slug: 'obeid', population: 393311 },
      { name: 'Nyala', slug: 'nyala', population: 565734 },
      { name: 'Wad Medani', slug: 'wad-medani', population: 332714 },
      { name: 'El Fasher', slug: 'el-fasher', population: 264734 },
      { name: 'El Geneina', slug: 'el-geneina', population: 192045 },
      { name: 'Atbara', slug: 'atbara', population: 134090 },
      { name: 'Damazin', slug: 'damazin', population: 102709 },
      { name: 'Dongola', slug: 'dongola', population: 82594 },
      { name: 'Kosti', slug: 'kosti', population: 173599 },
      { name: 'Gedaref', slug: 'gedaref', population: 269395 },
      { name: 'El Obeid', slug: 'el-obeid', population: 393311 },
      { name: 'Sennar', slug: 'sennar', population: 103680 },
      { name: 'Kassala State', slug: 'kassala-state', population: 167149 },
      { name: 'Halfa', slug: 'halfa', population: 56000 },
      { name: 'Rabak', slug: 'rabak', population: 180827 },
      { name: 'Shendi', slug: 'shendi', population: 81029 },
      { name: 'Berber', slug: 'berber', population: 61452 },
      { name: 'Sinkat', slug: 'sinkat', population: 58335 },
      { name: 'Tokar', slug: 'tokar', population: 44251 },
      { name: 'Karima', slug: 'karima', population: 13213 },
      { name: 'Merowe', slug: 'merowe', population: 47783 },
      { name: 'Ed Dueim', slug: 'ed-dueim', population: 71403 },
      { name: 'Kadugli', slug: 'kadugli', population: 83355 },
      { name: 'Dilling', slug: 'dilling', population: 44141 }
    ]
  }
];
